module.exports = __webpack_public_path__ + "img/logo-square.e9838401.png";